import React from 'react';
import { arrayOf, func, number, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import ThirdPage from './ThirdPage';
import { selectCategory as selectCategoryAction } from './redux/actions/uiActions';
import { categoryOptions } from './utils';

export function ThirdPageContainer({
  categoryDetails,
  handleSubmit,
  previousPage,
  selectCategory,
  selectedCategory
}) {
  const findSelectedCategory = () => {
    if (selectedCategory.value) {
      return selectedCategory;
    }

    return categoryOptions.find(
      (option) => option.value === categoryDetails[0].category_id
    );
  };

  return (
    <ThirdPage
      categoryDetails={categoryDetails}
      categoryOptions={categoryOptions}
      onSubmit={handleSubmit}
      previousPage={previousPage}
      selectCategory={selectCategory}
      selectedCategory={findSelectedCategory()}
    />
  );
}

ThirdPageContainer.propTypes = {
  categoryDetails: arrayOf(shape({})).isRequired,
  handleSubmit: func.isRequired,
  previousPage: func.isRequired,
  selectCategory: func.isRequired,
  selectedCategory: shape({
    label: string,
    value: number
  }).isRequired
};

const mapStateToProps = ({ ui: { selectedCategory }, ...state }) => {
  const selector = formValueSelector('partnerSubmissionForm');
  const {
    category_ids: selectedCategoryIds,
    category_details: categoryDetails
  } = selector(state, 'category_ids', 'category_details');
  return {
    categoryDetails,
    selectedCategory,
    selectedCategoryIds
  };
};

export default connect(mapStateToProps, {
  selectCategory: selectCategoryAction
})(ThirdPageContainer);
